var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNzBgCardUpWhiteE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100px",
    viewBox: "0 0 1280 140",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640 139L0 42v98h1280V42l-640 97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzBgCardUpWhiteE);
export default __webpack_public_path__ + "static/media/nz-bg-card-up-white-e.d28628f00f92d000634c9a30dc12a195.svg";
export { ForwardRef as ReactComponent };